/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.AmazonDateRangeRulesResponseDto>
>;
export function request(
  params: API.basics.amazonDateRangeRules.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/amazonDateRangeRules/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
